import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowCircleRightOutlined } from '@mui/icons-material';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import { MaterialBoolControl } from 'console/shared/components/fields';
import { memo, useCallback, useContext, useMemo, Fragment, } from 'react';
import { Z3KSettings, Z3KSettingsEditor } from '../../../provider/types';
import * as _ from 'lodash';
import { getZ3kEntityById } from 'z3k-parser/lib';
function SelectItemsPageImpl(props) {
    const { parent_url, elements, selected, onSelected, goChildLink } = props;
    const { service_view } = useContext(Z3KSettings);
    const { config } = useContext(Z3KSettingsEditor);
    const getFlagElement = useCallback((id) => {
        const flag = selected.findIndex((el) => el === id);
        return flag == -1 ? false : true;
    }, [selected]);
    const ChangeSelectedList = useCallback((checked, id) => {
        const indexId = selected.findIndex((el) => el === id);
        const inArray = indexId !== -1 ? true : false;
        if (checked) {
            if (!inArray) {
                onSelected((prevState) => [...prevState, id]);
            }
        }
        else {
            if (inArray) {
                onSelected((prevState) => [
                    ...prevState.slice(0, indexId),
                    ...prevState.slice(indexId + 1, prevState.length),
                ]);
            }
        }
    }, [selected, onSelected]);
    const newArr = useMemo(() => elements.map((el) => {
        return {
            id: el.id,
            name: el.name,
            url: el.url,
            group: el.group
                ? el.group
                : el.objectid
                    ? getZ3kEntityById(config, el.objectid)[0]
                    : null,
        };
    }), [elements]);
    const groupBy = _.groupBy(newArr, 'group');
    return (_jsx(Box, { display: "flex", flexDirection: "column", gap: 1, ml: 2, children: Object.keys(groupBy).map((arr, index) => {
            return (_jsxs(Box, { children: [groupBy[arr].map((el, index) => {
                        const flag = getFlagElement(el.id);
                        return (_jsx(Fragment, { children: service_view ? (_jsxs(Box, { display: "flex", alignItems: "center", children: [_jsx(MaterialBoolControl, { color: "primary", label: el.name, value: flag, onChange: (checked) => ChangeSelectedList(checked, el.id) }), el.url && parent_url && (_jsx(IconButton, { size: "small", onClick: () => goChildLink(parent_url, el?.url ?? null, el.id), children: _jsx(ArrowCircleRightOutlined, {}) }))] }, `${el.id}.${index}`)) : (flag && (_jsxs(Box, { display: "flex", alignItems: "center", children: [_jsx(Typography, { variant: "subtitle1", children: el.name }), el.url && parent_url && (_jsx(IconButton, { size: "small", onClick: () => goChildLink(parent_url, el?.url ?? null, el.id), children: _jsx(ArrowCircleRightOutlined, {}) }))] }, `${el.id}.${index}`))) }, el.id));
                    }), _jsx(Divider, {}, arr)] }, `${arr}-${index}`));
        }) }, `section-${parent_url}`));
}
export const SelectItemsPage = memo(SelectItemsPageImpl);
